module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Physical Resources List")]), _vm._v(" "), _c('div', {
    staticClass: "action-button pull-right"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "reset-input",
      rawName: "v-reset-input"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResource),
      expression: "searchResource"
    }],
    staticClass: "form-control mrgn-right-20px searchBox",
    attrs: {
      "type": "text",
      "placeholder": "Type here to search and press 'Enter'"
    },
    domProps: {
      "value": (_vm.searchResource)
    },
    on: {
      "keyup": _vm.searchResources,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResource = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "virtual-resources-addOrUpdate"
    }
  }, [_vm._v("Add Physical Resources")])], 1)]), _vm._v(" "), (_vm.actionInProgress) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/loader/nivi-loader.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped table-apps"
  }, [_c('thead', [_c('th', [_vm._v("Resource Name "), _c('i', {
    staticClass: "fa fa-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortResources('data.full_name', 'asc')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortResources('data.full_name', 'desc')
      }
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', [_vm._v("Client "), _c('i', {
    staticClass: "fa fa-arrow-up",
    on: {
      "click": function($event) {
        return _vm.sortResources('data.client_name', 'asc')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-arrow-down",
    on: {
      "click": function($event) {
        return _vm.sortResources('data.client_name', 'desc')
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Created On")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])]), _vm._v(" "), _c('tbody', [(_vm.resourcesData.length === 0 && !_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No Result found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.resourcesData), function(keyword, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.resourcesData.length),
        expression: "resourcesData.length"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(keyword.full_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(keyword.country_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(keyword.client_name))]), _vm._v(" "), _c('td', [(keyword.createdAt) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(keyword.createdAt, 'd/M/Y hh:ss')))]) : _vm._e(), _vm._v(" "), (!keyword.createdAt) ? _c('span', [_vm._v("--")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("virtual-resources-addOrUpdate?resourceId=" + (keyword.id))
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteConfirmationPopup(keyword, index)
        }
      }
    })])])
  })], 2)])])])])])]), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('deleteConfirmationModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteResources": _vm.deleteResources
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [(_vm.pageCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "click-handler": _vm.getDataForSelectedPage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Physical Resources Management\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Resources")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Physical Resources List")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-509f41a1","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources-management/physical/physicalList.vue
// module id = orrA
// module chunks = 1